import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PagamentoFolhaListarComponent } from './pagamento-folha-listar/pagamento-folha-listar.component';

const routes: Routes = [];

@NgModule({
  imports: [RouterModule.forChild([
    {path: '', component: PagamentoFolhaListarComponent}
  ])],
  exports: [RouterModule]
})
export class PagamentoFolhaRoutingModule { }
